export default __webpack_public_path__ + "static/media/faq-1.855e4011.png";